// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"453":"10f0caca","671":"1e374017","959":"e22d9f20"}[chunkId] + ".chunk.js");